import { useState } from "react";
import DSDialog from "../system-design/DSDialog";
import DSDialogActions from "../system-design/DSDialogActions";
import DSPrimaryButton from "../system-design/DSPrimaryButtom";
import DSSecondaryButton from "../system-design/DSSecondaryButton";
import DSBox from "../system-design/DSBox";
import DSTextField from "../system-design/DSTextField";
import DSTypography from "../system-design/Typography/DSTypography";
import DSCircularProgress from "../system-design/DSCircularProgress";
import giftClient, { GiftInformation } from "../../api/gift";
import { KLYDO_BLACK } from "../../consts/colors";

export type EnterOrderDialogProps = {
  open: boolean;
  onClose: () => void;
  onConfirm: (giftInfo: GiftInformation, orderName: string) => void;
};

const EnterOrderDialog = ({
  open,
  onClose,
  onConfirm,
}: EnterOrderDialogProps) => {
  const [orderName, setOrderName] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [cannotAddGreetError, setCannotAddGreetError] = useState(false);

  const handleOrderNameChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    setIsError(false);
    setCannotAddGreetError(false);
    setOrderName(event.target.value);
  };

  const handlePressAdd = async () => {
    try {
      setIsLoading(true);
      const giftInfo = await giftClient.getGift({ orderName });
      if (giftInfo?.clockInfo?.registerProduct && !giftInfo?.gift) {
        setCannotAddGreetError(true);
        setIsLoading(false);
        return;
      }
      if (giftInfo) {
        setIsLoading(false);
        onConfirm(giftInfo, orderName);
      }
    } catch (error) {
      setIsLoading(false);
      setIsError(true);
      return;
    }
  };

  const errorMessage = () => {
    if (isError) {
      return (
        <DSTypography
          fontFamily={"Gilroy-Medium"}
          fontSize={"14px"}
          fontWeight={400}
          lineHeight={"24px"}
          color="error"
        >
          Order not found
        </DSTypography>
      );
    }
    if (cannotAddGreetError) {
      return (
        <DSTypography
          fontFamily={"Gilroy-Medium"}
          fontSize={"14px"}
          fontWeight={400}
          lineHeight={"24px"}
          color="error"
        >
          Cannot add greet to order with registered clock
        </DSTypography>
      );
    }
    return null;
  };

  const handleClose = () => {
    setIsError(false);
    setCannotAddGreetError(false);
    setOrderName("");
    onClose();
  };

  return (
    <DSDialog open={open} onClose={handleClose} title="Enter Order Name">
      <DSBox
        sx={{
          padding: 3,
          display: "flex",
          flexDirection: "column",
          gap: 2,
        }}
      >
        <DSTypography
          fontFamily={"Gilroy-Medium"}
          fontSize={"24px"}
          fontWeight={400}
          lineHeight={"24px"}
        >
          Enter Order Name
        </DSTypography>
        <DSTextField
          placeholder="P2335555"
          onChange={handleOrderNameChange}
          value={orderName}
        />
        {errorMessage()}
      </DSBox>
      <DSDialogActions sx={{ justifyContent: "flex-end", padding: 3, gap: 2 }}>
        <DSSecondaryButton onClick={handleClose}>Cancel</DSSecondaryButton>
        <DSPrimaryButton
          onClick={() => handlePressAdd()}
          disabled={!orderName}
          sx={{ padding: "14px 40px" }}
        >
          {isLoading ? (
            <DSCircularProgress size={20} sx={{ color: KLYDO_BLACK }} />
          ) : (
            "Add"
          )}
        </DSPrimaryButton>
      </DSDialogActions>
    </DSDialog>
  );
};
export default EnterOrderDialog;
